/*
 * The Android app's build variant (docs/API.md → Enums, ApkVariant; SHELL.md §4.1): tv-api
 * derives it from the APK's signer. A box only installs updates of the variant it runs.
 */
export enum ApkVariant {
    Standard = 'standard',
    Platform = 'platform',
}

export const APK_VARIANTS: ApkVariant[] = [ApkVariant.Standard, ApkVariant.Platform]

/*
 * The system components tv-api may offer platform shells (docs/API.md → Enums, ComponentPackage;
 * SHELL.md §4.2): the AOSP WebView of test-key firmwares and Google's.
 */
export const COMPONENT_PACKAGES = ['com.android.webview', 'com.google.android.webview']
